module.exports = __webpack_public_path__ + "static/media/ic-cart-open-white.68d66736.svg";